<template>
  <router-view />
  <UpdateReloadModal
    :open="updatePrompt.open"
    :remaining="updatePrompt.remaining"
    :progress="updatePrompt.progress"
    :updating="updatePrompt.updating"
    :source="updatePrompt.source"
    @refresh="applyUpdate"
  />
</template>

<script>
import UpdateReloadModal from './components/UpdateReloadModal.vue';
import { UPDATE_EVENT, applyAppUpdate } from './services/sw';

const COUNTDOWN_MS = 10000;
const TICK_MS = 100;

export default {
  name: 'AppRoot',
  components: {
    UpdateReloadModal,
  },
  data() {
    return {
      updatePrompt: {
        open: false,
        remaining: 10,
        progress: 0,
        updating: false,
        source: '',
        registration: null,
      },
      countdownTimer: null,
    };
  },
  mounted() {
    window.addEventListener(UPDATE_EVENT, this.handleUpdateAvailable);
  },
  beforeUnmount() {
    window.removeEventListener(UPDATE_EVENT, this.handleUpdateAvailable);
    this.clearCountdown();
  },
  methods: {
    handleUpdateAvailable(event) {
      const detail = event?.detail || {};
      this.updatePrompt = {
        open: true,
        remaining: 10,
        progress: 0,
        updating: false,
        source: detail.source || '',
        registration: detail.registration || null,
      };
      this.startCountdown();
    },
    startCountdown() {
      this.clearCountdown();
      let elapsed = 0;
      this.countdownTimer = window.setInterval(() => {
        elapsed += TICK_MS;
        const remainingMs = Math.max(0, COUNTDOWN_MS - elapsed);
        this.updatePrompt.progress = Math.min(100, Math.round((elapsed / COUNTDOWN_MS) * 100));
        this.updatePrompt.remaining = Math.max(0, Math.ceil(remainingMs / 1000));

        if (elapsed >= COUNTDOWN_MS) {
          this.clearCountdown();
          this.applyUpdate();
        }
      }, TICK_MS);
    },
    clearCountdown() {
      if (this.countdownTimer) {
        window.clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    applyUpdate() {
      if (this.updatePrompt.updating) return;
      this.updatePrompt.updating = true;
      this.clearCountdown();
      applyAppUpdate(this.updatePrompt.registration);
    },
  },
};
</script>
